import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map} from 'rxjs/operators';
import {of} from 'rxjs';
import * as MultishareHistoryActions from './multishare-history.actions';
import {MultishareHistoryClientService} from './multishare-history-client.service';
import {errorHappened} from '../../app.types';


@Injectable()
export class MultishareHistoryEffects {

  loadMultishareHistorys$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MultishareHistoryActions.loadMultishareHistorys),
      concatMap((action) => this.client.fetchEntries(action.filter)),
      map(data => MultishareHistoryActions.loadMultishareHistorysSuccess({historiesPage: data})),
      catchError(err => of(errorHappened({error: {message: err.message}})))
    );
  });


  constructor(private actions$: Actions, private client: MultishareHistoryClientService) {
  }
}
